export default __webpack_public_path__ + "static/media/ic_usdc(m)_24.0952740b.svg";